// 正式なホスト（entry.trunklyne.com）以外（web.app・firebaseapp.com）で開かれたページを、検索に載せないようにする（planning/2026-10-20-SEOとSNS共有.md）。
// 決済のあとの戻り先などの動きは変えない。開発のときの localhost も検索に載らないので同じ扱いにする
export const PRIMARY_HOST = "entry.trunklyne.com";
export const shouldNoindex = (hostname: string) => hostname.toLowerCase() !== PRIMARY_HOST;
export function markNoindexOnOtherHosts(doc: Document = document, hostname: string = location.hostname) {
  if (!shouldNoindex(hostname) || doc.querySelector('meta[name="robots"]')) return;
  const m = doc.createElement("meta"); m.name = "robots"; m.content = "noindex"; doc.head.appendChild(m);
}
